import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=00ec8f1a&"
import script from "./BoxInfo.vue?vue&type=script&lang=js&"
export * from "./BoxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports